export const flightPage = {
    АСOperator: ['Эксплуатант', 'АС operator'],
    ACReg: ['Бортовой №', 'AC reg.'],
    adt: ['ВЗ', 'ADT'],
    airportInfo: ['Информация по аэропортам', 'Airport info'],
    baggage: ['Багаж', 'Baggage'],
    bcl: ['B/cl', 'B/cl'],
    cargo: ['Груз', 'Cargo'],
    chd: ['РБ', 'CHD'],
    comment: ['Комментарий', 'Comment'],
    communication: ['Вид сообщения', 'Communication'],
    delay: ['Задержка', 'Delay'],
    flight: ['Рейс', 'Flight'],
    flightInfo: ['Информация о рейсе', 'Flight info'],
    flightComment: ['Комментарий к рейсу', 'Flight comment'],
    flightMeanType: ['Цель полёта', 'Flight mean type'],
    flightTask: ['Полётное задание', 'Flight task'],
    flightType: ['Категория рейса', 'Flight type'],
    inf: ['РМ', 'INF'],
    load: ['Загрузка', 'Load'],
    loadInfo: ['Информация по загрузке', 'Load info'],
    mail: ['Почта', 'Mail'],
    mainFlightInfo: ['Основная информация по рейсу', 'Main flight info'],
    mtow: ['MTOW', 'MTOW'],
    noData: ['Нет данных', 'There is not data'],
    passengers: ['Пассажиры', 'Passengers'],
    preliminaryInfo: ['Предварительная информация', 'Preliminary info'],
    route: ['Маршрут', 'Route'],
    seatConfiguration: ['Компоновка ВС', 'Seat сonfiguration'],
    stand: ['Стоянка', 'Stand'],
    status: ['Статус', 'Status'],
    upliftFact: ['Заправка факт', 'Uplift fact'],
    upliftPlan: ['Заправка план', 'Uplift plan'],
    version: ['Компоновка', 'Version'],

    wizardStep: {
        arr: ['ARR', 'ARR'],
        dep: ['DEP', 'DEP'],
        loadFuel: ['Загрузка / Топливо', 'Load / Fuel'],
        navRoute: ['План полёта', 'Nav route'],
        start: ['Старт', 'Start'],
        total: ['Итог', 'Total'],
    },
};
